import { render, staticRenderFns } from "./SfCheckbox.vue?vue&type=template&id=5125ee6a&scoped=true&"
import script from "./SfCheckbox.vue?vue&type=script&lang=js&"
export * from "./SfCheckbox.vue?vue&type=script&lang=js&"
import style0 from "./SfCheckbox.vue?vue&type=style&index=0&id=5125ee6a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5125ee6a",
  null
  
)

export default component.exports